<div class="integration-status-container">
    <scaffold-integration-banner 
    *ngFor="let integration of integrations" 
    [integration]="integration"
    [selectable]="roleData?.view_integrations && integration.integration_type !== 'live_event' && integration.integration_type !== 'dwh'"
    [canRefreshState]="roleData?.manage_integrations && integration.integration_type !== 'live_event' && integration.integration_type !== 'dwh'"
    [showEditIcon]="roleData?.manage_integrations && integration.integration_type !== 'dwh' && integration.integration_type !== 'live_event'"
    [fullClickInfo]="true"
    (editClicked)="handleBannerEditClick($event)"
    ></scaffold-integration-banner>
</div>

